var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "side-wrapper"
  }, [_c("logo", {
    attrs: {
      collapse: _vm.collapsed
    }
  }), _c("scroll-bar", {
    staticClass: "side-main"
  }, [_c("a-menu", {
    attrs: {
      mode: _vm.mode,
      "inline-collapsed": !_vm.collapsed,
      theme: "dark",
      selectedKeys: [_vm.$route.path],
      "open-keys": _vm.openKeys
    },
    on: {
      openChange: _vm.changeOpen
    }
  }, [_vm._l(_vm.baseRoute, function (item) {
    return [!item.children && !item.hidden ? _c("menu-item", {
      key: item.path,
      attrs: {
        currentRoute: item,
        customerId: _vm.customerId || 0
      },
      on: {
        visibleChange: item => _vm.visibleChange(item)
      }
    }) : _vm._l(item.children, function (temp) {
      return [!temp.children ? _c("menu-item", {
        key: temp.path,
        attrs: {
          currentRoute: temp,
          customerId: _vm.customerId || 0
        }
      }) : _c("sub-menu", {
        key: temp.path,
        attrs: {
          currentRoute: temp,
          customerId: _vm.customerId || 0
        }
      })];
    })];
  })], 2)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };